'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosMoonOutline = function IoIosMoonOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.7 24.6c0.6 0 1.1-0.1 1.7-0.2-0.3 0.5-0.6 0.9-1 1.4-1.6 1.9-4.1 3.2-6.8 3.2-5 0-9.1-4-9.1-9 0-4.1 2.7-7.5 6.3-8.7 0.6-0.1 1.1-0.2 1.7-0.3-0.3 0.5-0.6 1-0.8 1.4-0.6 1.1-0.9 2.4-0.9 3.7 0 2.3 0.9 4.4 2.5 6s3.8 2.5 6 2.5h0.4z m-6.1 3.1c1.9 0 3.7-0.7 5-1.8-5-0.4-9-4.7-9-9.8 0-1.1 0.1-2.2 0.4-3.1-2.5 1.2-4.2 4-4.2 7 0 4.3 3.5 7.7 7.8 7.7z' })
        )
    );
};

exports.default = IoIosMoonOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-moon-outline.js
// module id = 2450
// module chunks = 0